export default "__VITE_ASSET__bVK5kmJt__"